import React,{useState,useEffect} from 'react';
import { useParams, useNavigate } from "react-router-dom";
import shots from "./../shots.js";
import './CountryShots.scss';
import Breadcrumb from '../../BreadCrumb/BreadCrumb.jsx';


function CountryShots({ country, description }) {
const { index, idx } = useParams();

const ContinentIndex=Number(index);
const CountryIndex=Number(idx);
const navigate=useNavigate();


  return (
    <>
    <Breadcrumb paths={[{name:"Home",path:"/dashboard"},
     {name:"Tips",path:""}]}/>
    <div className="flying-tip-card">
      
      <h2 className="title">Aerial Borne Flying Tips</h2>
      <div className="card">
        <h3 className="country">{shots[ContinentIndex].countries[CountryIndex].country}</h3>
        <p className="description">{shots[ContinentIndex].countries[CountryIndex].description}</p>
        <p className="additional-text">
          To help you fly your drone safely and responsibly, we've listed some important drone flight regulations and battery transportation policies below:
          </p>
          <br/>
          <p className='rules'>•{"     "}{shots[ContinentIndex].countries[CountryIndex].droneRules[0]}</p>
          
          <p className='rules'>•{"     "}{shots[ContinentIndex].countries[CountryIndex].droneRules[1]}</p>

        <div className="buttons">
          <button className="btn privacy"
          onClick={()=>{navigate('privacy-policy')}}
          >Visit Privacy Policies</button>
          <button className="btn faq">Visit Platform FAQ</button>
        </div>
      </div>
    </div>
    </>
  )
}

export default CountryShots;